import { Themes } from './config';
import { themeChangedEvent } from './forum-theme';

export interface UserPreferences { theme: string; wordSuggestions: boolean; }
export const wordSuggestionsChangedEvent = 'triad-word-completion-preference';
let memory: UserPreferences | null = null;
export function browserUserPreferences(): UserPreferences {
    if (memory) return memory;
    try {
        return normaliseUserPreferences({ theme: localStorage.getItem('selected-theme'),
            wordSuggestions: localStorage.getItem('triad.english-word-completion') === 'on' });
    } catch { return { theme: 'lara-light-blue', wordSuggestions: false }; }
}
export function normaliseUserPreferences(value: any): UserPreferences {
    return { theme: Themes.some(theme => theme.value === value?.theme) ? value.theme : 'lara-light-blue',
        wordSuggestions: value?.wordSuggestions === true };
}
export function applyUserPreferences(value: UserPreferences): void {
    const next = normaliseUserPreferences(value);
    memory = next;
    try {
        localStorage.setItem('selected-theme', next.theme);
        localStorage.setItem('triad.english-word-completion', next.wordSuggestions ? 'on' : 'off');
        memory = null;
    } catch { /* Keep the preferences available when browser storage is blocked. */ }
    window.dispatchEvent(new Event(themeChangedEvent));
    window.dispatchEvent(new Event(wordSuggestionsChangedEvent));
}
